export type RadialPosition = { xOffset: number; yOffset: number };

export const getRadialMenuPositions = (count: number): RadialPosition[] => {
  const positions: RadialPosition[] = [];
  const normalizedCount = Math.max(0, Math.min(count, 6));
  // Fixed spacing for full-width options (center-aligned)
  const fullWidthSpacing = 35; // Distance between full-width options
  // Fixed gap between options that share a row
  const horizontalSpacing = 76; // Fixed spacing for options that share a row (reduced by 20%)
  const topOuterY = -90;
  const topInnerY = topOuterY + fullWidthSpacing; // -55
  const bottomInnerY = -topInnerY; // 55 (symmetric)
  const bottomOuterY = -topOuterY; // 90 (symmetric)

  if (normalizedCount === 1) {
    // 1: one option above center (full width)
    positions.push({ xOffset: 0, yOffset: topOuterY });
  } else if (normalizedCount === 2) {
    // 2: one top center (upper group) + one bottom center (lower group)
    positions.push({ xOffset: 0, yOffset: topOuterY });
    positions.push({ xOffset: 0, yOffset: bottomOuterY });
  } else if (normalizedCount === 3) {
    // 3: one top outer + one top inner center + one bottom outer center
    positions.push({ xOffset: 0, yOffset: topOuterY });
    positions.push({ xOffset: 0, yOffset: topInnerY });
    positions.push({ xOffset: 0, yOffset: bottomOuterY });
  } else if (normalizedCount === 4) {
    // 4: top(1 outer center + 1 inner center) + bottom(1 inner center + 1 outer center)
    positions.push({ xOffset: 0, yOffset: topOuterY });
    positions.push({ xOffset: 0, yOffset: topInnerY });
    positions.push({ xOffset: 0, yOffset: bottomInnerY });
    positions.push({ xOffset: 0, yOffset: bottomOuterY });
  } else if (normalizedCount === 5) {
    // 5: top(1+2) + bottom(2)
    positions.push({ xOffset: 0, yOffset: topOuterY });
    positions.push({ xOffset: -horizontalSpacing, yOffset: topInnerY });
    positions.push({ xOffset: horizontalSpacing, yOffset: topInnerY });
    positions.push({ xOffset: -horizontalSpacing, yOffset: bottomInnerY });
    positions.push({ xOffset: horizontalSpacing, yOffset: bottomInnerY });
  } else if (normalizedCount === 6) {
    // 6: top(1+2) + bottom(2+1)
    positions.push({ xOffset: 0, yOffset: topOuterY });
    positions.push({ xOffset: -horizontalSpacing, yOffset: topInnerY });
    positions.push({ xOffset: horizontalSpacing, yOffset: topInnerY });
    positions.push({ xOffset: -horizontalSpacing, yOffset: bottomInnerY });
    positions.push({ xOffset: horizontalSpacing, yOffset: bottomInnerY });
    positions.push({ xOffset: 0, yOffset: bottomOuterY });
  }

  return positions;
};
